export function getDefaultActivityType(): string | null | undefined {
    return typeof NutshellFrontendSettings !== 'undefined'
        ? NutshellFrontendSettings.defaultActivityType
        : null;
}
